import { render, staticRenderFns } from "./AddEditReadServiceAssistant.vue?vue&type=template&id=7a2debae"
import script from "./AddEditReadServiceAssistant.vue?vue&type=script&lang=js"
export * from "./AddEditReadServiceAssistant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports